var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD1CookerHood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 33.16V39H17v-5.84l14-9.73V7h14v16.43l14 9.73zM49 51.5a6.33 6.33 0 01-1.56 4.2 6.89 6.89 0 01-5.21 2.3H31.71A6.7 6.7 0 0025 64.71V69h4v-4.29A2.71 2.71 0 0131.71 62h10.62a11.132 11.132 0 003.73-.66 10.59 10.59 0 004.43-3 10.43 10.43 0 001.67-2.69A10.63 10.63 0 0053 51.5V51h-4v.5zM33.33 55A10.47 10.47 0 0044 44.5h-4a6.51 6.51 0 01-6.67 6.5H30c-6.87.27-12 5.88-12 13.28V69h4v-4.69c0-5.39 3.79-9.31 9-9.31h2.33z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/D1_Cooker_hood.6f464e01.svg";
export { SvgD1CookerHood as ReactComponent };